import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-dynamic-confirmation-dialog',
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    TranslatePipe
  ],
  templateUrl: './dynamic-confirmation-dialog.component.html',
  styleUrl: './dynamic-confirmation-dialog.component.scss'
})
export class DynamicConfirmationDialogComponent {
  protected data = inject(MAT_DIALOG_DATA);
}
